/*
 * Auto Acceptance Dashboard Messages
 *
 * This contains all the text for the Auto Acceptance component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.AutoAcceptance';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Auto-Acceptance',
  },
  searchProjectNamePlaceholder: {
    id: `${scope}.searchProjectNamePlaceholder`,
    defaultMessage: 'Project Name',
  },
  searchProjectIdPlaceholder: {
    id: `${scope}.searchProjectIdPlaceholder`,
    defaultMessage: 'Project IDs (comma separated)',
  },
  projectIdColumnLabel: {
    id: `${scope}.projectIdColumnLabel`,
    defaultMessage: 'Project ID',
  },
  projectNameColumnLabel: {
    id: `${scope}.projectNameColumnLabel`,
    defaultMessage: 'Project Name',
  },
  shiftCountColumnLabel: {
    id: `${scope}.shiftCountColumnLabel`,
    defaultMessage: 'Shift Count',
  },
  openShiftPercentColumnLabel: {
    id: `${scope}.openShiftPercentColumnLabel`,
    defaultMessage: 'Open Shift (%)',
  },
  shiftHoursColumnLabel: {
    id: `${scope}.shiftHoursColumnLabel`,
    defaultMessage: 'Shift Hours',
  },
  openShiftHoursColumnLabel: {
    id: `${scope}.openShiftHoursColumnLabel`,
    defaultMessage: 'Open Shift Hours',
  },
  suggestionAccepted: {
    id: `${scope}.suggestionAccepted`,
    defaultMessage: 'Suggestion accepted successfully',
  },
  suggestionRejected: {
    id: `${scope}.suggestionRejected`,
    defaultMessage: 'Suggestion rejected successfully',
  },
  applicationVetoed: {
    id: `${scope}.applicationVetoed`,
    defaultMessage: 'Application vetoed successfully',
  },
});
